<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">Relatório de Cobranças</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="four wide field">
                <label for="invoices-report-covenant">Convênio</label>
                <select
                  id="invoices-report-covenant"
                  class="ui dropdown"
                  v-model="form.covenant"
                >
                  <option
                    v-for="(covenant, index) in paymentMethods"
                    :key="index"
                    :value="covenant.name"
                  >
                    {{ covenant.description }}
                  </option>
                </select>
              </div>
              <div class="ui field">
                <label for="">Data de Vencimento</label>
              </div>
              <div class="inline fields">
                <div
                  :class="[
                    'four wide',
                    { error: errors.due_date_start },
                    'field'
                  ]"
                  :data-content="errorsTo('due_date_start')"
                >
                  <label for="invoices-report-due-date-start">De:</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoices-report-due-date-start"
                    v-model="form.due_date_start"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.due_date_end },
                    'field'
                  ]"
                  :data-content="errorsTo('due_date_end')"
                >
                  <label for="invoices-report-due-date-end">Até</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoices-report-due-date-end"
                    v-model="form.due_date_end"
                  />
                </div>
              </div>
              <div class="four wide field">
                <label for="invoices-report-days-of-delay"
                  >Dias em atraso</label
                >
                <input
                  type="number"
                  min="0"
                  step="1"
                  id="invoices-report-days-of-delay"
                  v-model="form.days_of_delay"
                />
              </div>
              <div class="ui field">
                <label for="">Quantidade de Parcelas em Atraso</label>
              </div>
              <div class="inline fields">
                <div class="four wide field">
                  <label for="invoices-report-late-invoices-min">De:</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    id="invoices-report-late-invoices-min"
                    v-model="form.late_invoices_min"
                  />
                </div>
                <div class="four wide field">
                  <label for="invoices-report-late-invoices-max">Até</label>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    id="invoices-report-late-invoices-max"
                    v-model="form.late_invoices_max"
                  />
                </div>
              </div>
              <div class="field">
                <label for="invoices-report-plans"> Planos </label>
                <select
                  id="invoices-report-plans"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.plans"
                >
                  <option
                    v-for="(plan, index) in plans"
                    :key="index"
                    :value="plan.id"
                  >
                    {{ plan.description }} - {{ plan.id }}
                  </option>
                </select>
              </div>
              <div class="field">
                <label for="invoice-report-city">Cidade</label>
                <CityInput
                  @selected="cityData => (form.city_ibge_code = cityData.value)"
                  ref="city"
                ></CityInput>
              </div>
              <div class="four wide field">
                <label for="invoice-report-layout"> Modelo de relatório </label>
                <select
                  id="invoice-report-layout"
                  class="ui dropdown"
                  v-model="layout"
                >
                  <option
                    v-for="(layout, index) in layouts"
                    :key="index"
                    :value="layout.value"
                  >
                    {{ layout.description }}
                  </option>
                </select>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import CityInput from '@/components/city_input';
import { mapGetters } from 'vuex';

export default {
  components: { Breadcrumb, PageLayout, CityInput },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      plans: [],
      layout: 'billing',
      layouts: [
        { value: 'billing', description: 'Modelo 1' },
        { value: 'billing_2', description: 'Modelo 2' }
      ],
      form: {
        days_of_delay: null,
        late_invoices_min: null,
        late_invoices_max: null,
        plans: [],
        state: null,
        covenant: null,
        due_date_start: null,
        due_date_end: null,
        city_ibge_code: null
      }
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },

    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    })
  },

  mounted() {
    // this.getUsers();
    this.getData();
    $('.ui.dropdown').dropdown();
  },

  methods: {
    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    async getData() {
      this.loading = true;

      const plansQuery = {
        q: {
          enable_eq: true,
          s: ['id asc']
        }
      };

      try {
        const plansResponse = await Api.plans.search(plansQuery);
        this.plans = _.clone(plansResponse.data.plans);
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.loading = false;
      }
    },

    run() {
      this.loading = true;
      let data = {
        report: this.layout
      };

      if (
        !_.isEmpty(this.form.due_date_start) &&
        !_.isEmpty(this.form.due_date_end)
      ) {
        data.DUE_DATE_START = this.$moment(
          this.form.due_date_start,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');

        data.DUE_DATE_END = this.$moment(
          this.form.due_date_end,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD');
      }

      if (this.form.city_ibge_code != null) {
        data.IBGE_CODE = this.form.city_ibge_code;

        const cityDescription = this.$refs.city.$el.children[3].textContent;
        data.CITY_DESCRIPTION = `'${cityDescription}'`;
      }

      if (!_.isEmpty(this.form.covenant)) {
        data.COVENANT = this.form.covenant;

        const covenantsDescription = this.paymentMethods.find(
          x => this.form.covenant == x.name
        ).description;

        data.COVENANTS_DESCRIPTIONS = `'${covenantsDescription}'`;
      }

      if (!_.isEmpty(this.form.days_of_delay)) {
        data.DAYS_OF_DELAY = this.form.days_of_delay;
      }

      const lateInvoicesMin = parseInt(this.form.late_invoices_min, 10);
      if (lateInvoicesMin >= 0) {
        data.LATE_INVOICES_MIN = lateInvoicesMin;
      }

      const lateInvoicesMax = parseInt(this.form.late_invoices_max, 10);
      if (lateInvoicesMax >= 0) {
        data.LATE_INVOICES_MAX = lateInvoicesMax;
      }

      if (this.form.plans.length > 0) {
        data.PLAN_IDS = this.form.plans.join(',');
      }

      Api.report(data)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
          $(this.$refs.modal).modal('show');
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }

    // getUsers() {
    //   this.loading = true;
    //   const query = {
    //     q: {
    //       rule_eq: 'collaborator',
    //       s: ['name asc']
    //     }
    //   };

    //   Api.users
    //     .search(query)
    //     .then(async response => {
    //       this.collaborators = _.clone(response.data.users);
    //     })
    //     .catch(error => {
    //       this.$toast.show('Erro ao buscar colaboradores', 'error');
    //       throw error;
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // }
  }
};
</script>
